module.exports = __webpack_public_path__ + "static/img/cheetah-4-arms.2cefa53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/benches/cheetah-4-arms.jpg
// module id = 496
// module chunks = 0